module.exports = __webpack_public_path__ + "static/whatsapp-1eb8210cf74a55e30e21cff52fec7dbd.png";